<template>
  <div class="mod-goods_info site-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/enterprise' }"> 企业信息 </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.id ? '企业详情' : '企业新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="lists">
      <div :class="['bus-tag', getSt]"></div>
      <p class="content_title">{{ $route.query.id ? '企业详情' : '企业新增' }}</p>
      <div style="width: 435px;margin:0 auto;text-align: center;margin-top: 16px;" v-if="dataForm.st == 'DEPT_AUDIT_F'">
        <img width="199" height="124" src="@/assets/img/shsb.png" />
        <p style="color: #FF6F77;font-size: 24px;font-weight: bold;margin-bottom:15px;margin-top:16px;">天啦！我审核失败了。</p>
        <p style="text-align: left;color: #FF6F77;line-height: 21px;max-width: 100%;width: fit-content;margin: 0 auto;">{{ dataForm.failCause }}</p>
        <div class="failAnnex clearFloat" v-if="dataForm.failUrls && dataForm.failUrls.fileDownloadUrl">
          <label class="fl">附件：</label>
          <div class="fl" style="text-align: left;max-width: 328px;">
            <a @click.prevent="downloadFile(dataForm.failUrls.fileDownloadUrl, dataForm.failUrls.fileName)">
              <span class="ellipsis">{{ dataForm.failUrls.fileName }}</span>
              <i class="el-icon-bottom"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="form_divider">
        <el-divider content-position="left">基本信息</el-divider>
      </div>

      <el-form class="enterprice_from" :model="dataForm" :disabled="dataForm.st != undefined && ['DEPT_AUDIT_T', 'DEPT_AUDIT_DSH'].includes(dataForm.st)" :rules="dataRule" ref="dataForm" label-width="95px">
        <el-row :gutter="48">
          <el-col :span="12">
            <el-form-item label="企业名称" prop="name">
              <el-select placeholder="" maxlength="50" class="w100" filterable allow-create v-model="dataForm.name" @change="setForm" :loading="loading" :remote-method="getOptions" remote>
                <el-option :label="op.name" :value="op.id" v-for="(op, i) of depts" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法人" prop="legalMan">
              <el-input :disabled="!!dataForm.id" v-model="dataForm.legalMan"></el-input>
            </el-form-item>
            <el-form-item label="纳税识别码" prop="ratepayCode">
              <el-input :disabled="!!dataForm.id" v-model="dataForm.ratepayCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照" prop="businessLicense">
              <el-upload accept=".jpg,.png,.pdf" :headers="headerSet" class="uploader" :action="upFilesUrl" :show-file-list="false" :on-success="(res, file) => { handleAvatarSuccess(res, file, 'businessLicense') }">
                <el-image v-if="dataForm.businessLicense && !dataForm.businessLicense.includes('.pdf')" :src="getUrl(dataForm.businessLicense)">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div class="uploadText" v-if="dataForm.businessLicense && dataForm.businessLicense.includes('.pdf')">
                  <a class="ellipsis" @click.prevent="openPdf(dataForm.businessLicense)">查看营业执照</a>
                </div>
                <i v-if="!dataForm.businessLicense" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="企业地址" prop="addr">
              <el-input :disabled="!!dataForm.id" v-model="dataForm.addr"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note">
              <el-input type="textarea" resize="none" rows="3" v-model="dataForm.note"></el-input>
            </el-form-item>
            <el-form-item label="填报凭证" prop="voucherUrls">
              <el-upload accept=".jpg,.png" :headers="headerSet" class="uploader" :action="upFilesUrl" :show-file-list="false" :on-success="(res, file) => { handleAvatarSuccess(res, file, 'voucherUrls') }">
                <el-image v-if="dataForm.voucherUrls" :src="getUrl(dataForm.voucherUrls)">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <i class="el-icon-plus" v-if="!dataForm.voucherUrls && (!dataForm.st || ['DEPT_AUDIT_F', 'DEPT_AUDIT_DTJ'].includes(dataForm.st))"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="bottom_btns" v-if="!['DEPT_AUDIT_DSH', 'DEPT_AUDIT_T'].includes(dataForm.st)">
        <el-button type="primary" round @click="upHandle('DEPT_AUDIT_DSH')" v-loading="submitting">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isCharacter } from "@/utils/validate";
import { downloadFile, previewUrl } from "@/utils";
export default {
  data() {
    var validateRatepayCode = (rule, value, callback) => {
      if (!isCharacter(value) && !this.dataForm.id) {
        callback(new Error("纳税识别码只能是数字或英文"));
      } else {
        callback();
      }
    };
    return {
      submitting: false,
      upFilesUrl: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload',
      dataForm: {
        name: "",
        legalMan: "",
        ratepayCode: "",
        businessLicense: '',
        addr: "",
        note: "",
        voucherUrls: "",
        st: '',
        id: ''
      },
      dataRule: {
        name: [{ required: true, message: "企业名称不能为空", trigger: "blur" }],
        addr: [{ required: true, message: "企业地址不能为空", trigger: "blur" }],
        ratepayCode: [{ validator: validateRatepayCode, trigger: "blur" }],
        businessLicense: [{ required: true, message: "请上传营业执照", trigger: "blur" }]
      },
      depts: [],
      loading:false
    };
  },
  created() {
    this.$route.query.id && this.deptDetail();
  },
  computed: {
    getSt() {
      let st = '';
      switch (this.dataForm.st) {
        case undefined:
          st = '';
          break;
        case 'DEPT_AUDIT_F':
          st = 'sb';
          break;
        case 'DEPT_AUDIT_DTJ':
          st = 'dtj';
          break;
        case 'DEPT_AUDIT_DSH':
          st = 'dsh';
          break;
        case 'DEPT_AUDIT_T':
          st = 'cg';
          break;
      }
      return st;
    },
    headerSet() {
      return { 'X-Admin-Token': this.$cookie.get('X-Admin-Token') }
    }
  },
  methods: {
    openPdf(url) {
       window.open(previewUrl(url));
    },
    getOptions(query){
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.$http.get(`${this.$api.shiroApi.searchDeptList}?searchKey=${query}`).then(({ data }) => {
                this.depts = data.data;
                this.loading = false;
            });
          }, 200);
        } else {
          this.depts = [];
        }
      },
    setForm(val) {
      const checkOne = this.depts.find(v => v.id == val);
      Object.keys(this.dataForm).forEach(v => {
        if (v != 'st') {
          this.dataForm[v] = checkOne ? checkOne[v] : '';
        }
      });
      if (!this.$route.query.id) {
        // 新增企业，不传relId，id可选
        delete this.dataForm.relId;
      }else{
        this.dataForm.relId = this.$route.query.id;
      }
      if (!checkOne) {
        delete this.dataForm.id
        this.dataForm.name = val;
      }
      this.$refs.dataForm.validate();
    },
    deptDetail() {
      this.$http.get(this.$api.shiroApi.deptById, { params: { relId: this.$route.query.id } }).then(({ data }) => {
        if (data.code === 200) {
          Object.keys(this.dataForm).forEach(v => {
            this.dataForm[v] = data.data[v];
          });
          this.dataForm.relId = this.$route.query.id;
          return
        }
        this.$message({
          message: data.msg,
          type: "error"
        });
      })
    },
    getUrl(url) {
      return previewUrl(url);
    },
    downloadFile(url, fileName) {
      downloadFile(url, fileName);
    },
    upHandle(st) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.dataForm,
            st: st
          }
          this.$http.post(this.$api.shiroApi[this.$route.query.id ? 'updateDept' : 'addDept'], params).then(({ data }) => {
            this.$message({
              message: data.msg,
              type: "success",
              duration: 1500,
              onClose: () => {
                this.$router.replace({ name: "enterprise" });
              }
            });
          });
        }
      });
    },
    handleAvatarSuccess(res, file, type) {
      if (res.code == 200) {
        this.dataForm[type] = res.data.storage.filePreviewUrl;
        this.$refs["dataForm"].validateField(type);
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lists {
  background: #fff;
  box-shadow: 0px 2px 31px 1px rgb(0 0 0 / 3%);
  border-radius: 16px;
  margin-bottom: 32px;
  padding-bottom: 47px;
}

.form_divider {
  display: flex;
  padding: 14px 77px;
  align-items: center;

  .el-button {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    width: 64px;
    height: 28px;
    padding: 0;
    border-radius: 14px;
    border: 1px solid #E6E6E6;
    margin-left: 16px;
  }

  .el-button--primary {
    color: #fff;
  }
}

.uploader {
  width: 320px;
  height: 156px;
  border-radius: 4px;
  border: 1px solid #DEDEDE;
  text-align: center;
  line-height: 156px;

  ::v-deep .el-upload {
    width: 100%;
    height: 100%;
  }

  .el-image {
    height: 154px;
  }

  i {
    font-size: 26px;
    width: 100%;
    color: #999;
  }
}

.content_table {
  .el-button {
    font-size: 14px;
    font-weight: bold;
  }
}

.enterprice_from {
  margin: 0 auto;
  width: 870px;

  .el-form-item {
    margin-bottom: 14px;
  }
}

::v-deep div.el-dialog__header {
  font-size: 14px;
  padding: 0;
  line-height: 55px;
  padding-left: 24px;
}

::v-deep .el-dialog__body {
  margin: 0 68px;

  .el-form-item {
    margin-bottom: 14px;
  }

  .el-select {
    width: 100%;
  }
}

::v-deep .el-dialog__footer {
  text-align: center;
  padding: 0;
  line-height: 87px;

  .el-button {
    border-radius: 20px;
    width: 160px;
    padding: 0;
    color: #666;
    font-size: 18px;
    line-height: 40px;
  }

  .el-button--primary {
    color: #fff;
  }
}

.bottom_btns {
  margin-top: 66px;
}

.el-form-item.is-error .uploader {
  border-color: #f56c6c;
}

.bus-tag.cg {
  background: url("~@/assets/img/cg.png") no-repeat center;
}

.bus-tag.sb {
  background: url("~@/assets/img/sb.png") no-repeat center;
}

.bus-tag.dsh {
  background: url("~@/assets/img/dsh.png") no-repeat center;
}

.bus-tag.dtj {
  background: url("~@/assets/img/dtj.png") no-repeat center;
}

.cell .el-button {
  padding: 3px 0px;
}
</style>
